/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'tool': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M1024 597.333V426.667l-126.834-14.08a396.146 396.146 0 00-42.496-102.713l79.673-99.556L813.653 89.6l-99.555 79.701a396.373 396.373 0 00-102.713-42.524L597.333 0H426.667l-14.109 126.777A395.776 395.776 0 00309.874 169.3L210.29 89.6 89.543 210.318l79.73 99.556a397.71 397.71 0 00-42.496 102.713L0 426.667v170.666l126.777 14.08a396.715 396.715 0 0042.496 102.685l-79.73 99.584L210.29 934.4l99.584-79.701a394.724 394.724 0 00102.684 42.496L426.667 1024h170.666l14.052-126.805a393.16 393.16 0 00102.656-42.496l99.612 79.701 120.69-120.718-79.673-99.613a392.192 392.192 0 0042.496-102.656L1024 597.333zm-512 56.89a142.25 142.25 0 010-284.445c78.45 0 142.222 63.658 142.222 142.222 0 78.478-63.772 142.222-142.222 142.222z"/>'
  }
})
